/**
 * Language registry + country/state → suggested language map.
 *
 * Drives the LanguagePicker (the user-facing list) and the suggestion toast
 * (which language to nudge based on detected IP location).
 *
 * Codes match Google Translate's element.js codes.
 */

export const LANGUAGES = [
  // - Indic
  { code: "en",     name: "English",            native: "English",          group: "Common" },
  { code: "hi",     name: "Hindi",              native: "हिन्दी",            group: "Indic" },
  { code: "gu",     name: "Gujarati",           native: "ગુજરાતી",          group: "Indic" },
  { code: "mr",     name: "Marathi",            native: "मराठी",            group: "Indic" },
  { code: "bn",     name: "Bengali",            native: "বাংলা",            group: "Indic" },
  { code: "ta",     name: "Tamil",              native: "தமிழ்",            group: "Indic" },
  { code: "te",     name: "Telugu",             native: "తెలుగు",           group: "Indic" },
  { code: "kn",     name: "Kannada",            native: "ಕನ್ನಡ",            group: "Indic" },
  { code: "ml",     name: "Malayalam",          native: "മലയാളം",          group: "Indic" },
  { code: "pa",     name: "Punjabi",            native: "ਪੰਜਾਬੀ",            group: "Indic" },
  { code: "ur",     name: "Urdu",               native: "اُردُو",             group: "Indic" },
  { code: "as",     name: "Assamese",           native: "অসমীয়া",          group: "Indic" },
  { code: "or",     name: "Odia",               native: "ଓଡ଼ିଆ",             group: "Indic" },
  { code: "sa",     name: "Sanskrit",           native: "संस्कृतम्",          group: "Indic" },
  { code: "ne",     name: "Nepali",             native: "नेपाली",            group: "Indic" },
  { code: "si",     name: "Sinhala",            native: "සිංහල",            group: "Indic" },

  // - Middle East & Africa
  { code: "ar",     name: "Arabic",             native: "العربية",          group: "Middle East" },
  { code: "fa",     name: "Persian",            native: "فارسی",            group: "Middle East" },
  { code: "he",     name: "Hebrew",             native: "עברית",            group: "Middle East" },
  { code: "tr",     name: "Turkish",            native: "Türkçe",           group: "Middle East" },
  { code: "sw",     name: "Swahili",            native: "Kiswahili",        group: "Africa" },
  { code: "am",     name: "Amharic",            native: "አማርኛ",            group: "Africa" },
  { code: "ha",     name: "Hausa",              native: "Hausa",            group: "Africa" },
  { code: "ig",     name: "Igbo",               native: "Igbo",             group: "Africa" },
  { code: "yo",     name: "Yoruba",             native: "Yorùbá",           group: "Africa" },
  { code: "zu",     name: "Zulu",               native: "isiZulu",          group: "Africa" },
  { code: "af",     name: "Afrikaans",          native: "Afrikaans",        group: "Africa" },

  // - East Asia
  { code: "zh-CN",  name: "Chinese (Simplified)", native: "简体中文",       group: "East Asia" },
  { code: "zh-TW",  name: "Chinese (Traditional)",native: "繁體中文",       group: "East Asia" },
  { code: "ja",     name: "Japanese",           native: "日本語",           group: "East Asia" },
  { code: "ko",     name: "Korean",             native: "한국어",           group: "East Asia" },

  // - Southeast Asia
  { code: "th",     name: "Thai",               native: "ไทย",              group: "Southeast Asia" },
  { code: "vi",     name: "Vietnamese",         native: "Tiếng Việt",       group: "Southeast Asia" },
  { code: "id",     name: "Indonesian",         native: "Bahasa Indonesia", group: "Southeast Asia" },
  { code: "ms",     name: "Malay",              native: "Bahasa Melayu",    group: "Southeast Asia" },
  { code: "fil",    name: "Filipino",           native: "Filipino",         group: "Southeast Asia" },

  // - Europe
  { code: "fr",     name: "French",             native: "Français",         group: "Europe" },
  { code: "de",     name: "German",             native: "Deutsch",          group: "Europe" },
  { code: "es",     name: "Spanish",            native: "Español",          group: "Europe" },
  { code: "pt",     name: "Portuguese",         native: "Português",        group: "Europe" },
  { code: "it",     name: "Italian",            native: "Italiano",         group: "Europe" },
  { code: "nl",     name: "Dutch",              native: "Nederlands",       group: "Europe" },
  { code: "pl",     name: "Polish",             native: "Polski",           group: "Europe" },
  { code: "ro",     name: "Romanian",           native: "Română",           group: "Europe" },
  { code: "sv",     name: "Swedish",            native: "Svenska",          group: "Europe" },
  { code: "fi",     name: "Finnish",            native: "Suomi",            group: "Europe" },
  { code: "no",     name: "Norwegian",          native: "Norsk",            group: "Europe" },
  { code: "da",     name: "Danish",             native: "Dansk",            group: "Europe" },
  { code: "el",     name: "Greek",              native: "Ελληνικά",         group: "Europe" },
  { code: "cs",     name: "Czech",              native: "Čeština",          group: "Europe" },
  { code: "hu",     name: "Hungarian",          native: "Magyar",           group: "Europe" },
  { code: "bg",     name: "Bulgarian",          native: "Български",        group: "Europe" },
  { code: "hr",     name: "Croatian",           native: "Hrvatski",         group: "Europe" },
  { code: "sk",     name: "Slovak",             native: "Slovenčina",       group: "Europe" },
  { code: "lt",     name: "Lithuanian",         native: "Lietuvių",         group: "Europe" },
  { code: "lv",     name: "Latvian",            native: "Latviešu",         group: "Europe" },
  { code: "et",     name: "Estonian",           native: "Eesti",            group: "Europe" },
  { code: "sl",     name: "Slovenian",          native: "Slovenščina",      group: "Europe" },
  { code: "ru",     name: "Russian",            native: "Русский",          group: "Europe" },
  { code: "uk",     name: "Ukrainian",          native: "Українська",       group: "Europe" },
];

const LOOKUP = LANGUAGES.reduce((m, l) => { m[l.code] = l; return m; }, {});

export const getLanguage = (code) => LOOKUP[code] || LOOKUP.en;

/**
 * State-aware mapping for India - Indian states with their official
 * language. Region names match what ipapi.co returns for IN locations.
 */
const INDIAN_STATE_LANG = {
  "Gujarat":            "gu",
  "Maharashtra":        "mr",
  "West Bengal":        "bn",
  "Tamil Nadu":         "ta",
  "Telangana":          "te",
  "Andhra Pradesh":     "te",
  "Karnataka":          "kn",
  "Kerala":             "ml",
  "Punjab":             "pa",
  "Haryana":            "hi",
  "Rajasthan":          "hi",
  "Uttar Pradesh":      "hi",
  "Uttarakhand":        "hi",
  "Madhya Pradesh":     "hi",
  "Bihar":              "hi",
  "Jharkhand":          "hi",
  "Chhattisgarh":       "hi",
  "Himachal Pradesh":   "hi",
  "Delhi":              "hi",
  "Jammu and Kashmir":  "ur",
  "Assam":              "as",
  "Odisha":             "or",
  "Sikkim":             "ne",
  "Goa":                "mr",
};

/**
 * Country → default language. Used when no state-specific match.
 * ISO 3166-1 alpha-2 country codes.
 */
const COUNTRY_LANG = {
  IN: "hi",   // India default - overridden by state map above
  PK: "ur",   NP: "ne",   BD: "bn",   LK: "si",   BT: "ne",
  // Middle East
  AE: "ar",   SA: "ar",   QA: "ar",   OM: "ar",   KW: "ar",
  BH: "ar",   IQ: "ar",   JO: "ar",   LB: "ar",   SY: "ar",
  YE: "ar",   EG: "ar",   PS: "ar",   IR: "fa",   AF: "fa",
  TR: "tr",   IL: "he",
  // Africa
  KE: "sw",   TZ: "sw",   UG: "sw",   RW: "sw",
  ET: "am",   NG: "en",   GH: "en",   ZA: "en",
  ZW: "en",   ZM: "en",   MA: "ar",   TN: "ar",   DZ: "ar",
  // East Asia
  CN: "zh-CN", HK: "zh-TW", TW: "zh-TW", JP: "ja",
  KR: "ko",   MO: "zh-TW",
  // Southeast Asia
  TH: "th",   VN: "vi",   ID: "id",   MY: "ms",   PH: "fil",
  SG: "en",   MM: "en",   KH: "en",   LA: "en",
  // Europe
  FR: "fr",   BE: "fr",   CH: "fr",   LU: "fr",
  DE: "de",   AT: "de",
  ES: "es",   AR: "es",   MX: "es",   CL: "es",   CO: "es",
  PE: "es",   VE: "es",   UY: "es",   PY: "es",   BO: "es",
  EC: "es",   CR: "es",   CU: "es",   DO: "es",   GT: "es",
  HN: "es",   NI: "es",   PA: "es",   PR: "es",   SV: "es",
  PT: "pt",   BR: "pt",   AO: "pt",   MZ: "pt",
  IT: "it",   VA: "it",   SM: "it",
  NL: "nl",
  PL: "pl",   RO: "ro",   SE: "sv",   FI: "fi",
  NO: "no",   DK: "da",   GR: "el",
  CZ: "cs",   HU: "hu",   BG: "bg",   HR: "hr",
  SK: "sk",   LT: "lt",   LV: "lv",   EE: "et",   SI: "sl",
  RU: "ru",   BY: "ru",   KZ: "ru",   KG: "ru",   UZ: "ru",
  TM: "ru",   TJ: "ru",   UA: "uk",
  // English-default
  US: "en",   GB: "en",   IE: "en",   CA: "en",   AU: "en",
  NZ: "en",   ZA_DEFAULT: "en",
};

/**
 * Resolve the suggested language for a (country, region) pair. Returns
 * `null` if no useful suggestion (e.g., already English-speaking + no
 * special override).
 */
export function suggestLanguage({ country, region }) {
  const c = (country || "").toUpperCase();

  // India: prefer state-specific language
  if (c === "IN") {
    return INDIAN_STATE_LANG[region] || COUNTRY_LANG.IN || null;
  }

  // Spain/Catalonia, Russia/Ukraine etc - could expand here
  // (kept to country-level for v1; structure makes it easy to add later)

  return COUNTRY_LANG[c] || null;
}
